import { useEffect, useRef, useState } from "react";
import { WarningCircle } from "@phosphor-icons/react";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const fmtQty = (q) => Number(q ?? 0).toLocaleString("pt-BR", { maximumFractionDigits: 3 });

export const ProductSearchInput = ({ value, onChange, onPick, products = [], className = "", testId, descIdx, placeholder = "Descrição do item", linkedLabel = null, onUnlink }) => {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = norm(value);
  const matches = q.length >= 2
    ? products.filter((p) => norm(p.name).includes(q) || (p.sku && norm(p.sku).includes(q))).slice(0, 8)
    : [];

  return (
    <div ref={boxRef} className="relative">
      <input data-testid={testId} data-desc-idx={descIdx} autoComplete="off" className={className}
        placeholder={placeholder} value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} />
      {linkedLabel && (
        <div data-testid={`${testId}-linked-badge`}
          className="mt-1 inline-flex items-center gap-1.5 max-w-full text-[11px] font-medium text-emerald-800 bg-emerald-50 border border-emerald-300 rounded-full px-2 py-0.5">
          <span className="truncate">Estoque: {linkedLabel}</span>
          <button type="button" data-testid={`${testId}-unlink`} title="Remover vínculo com o estoque"
            onMouseDown={(e) => { e.preventDefault(); onUnlink && onUnlink(); }}
            className="shrink-0 text-emerald-700 hover:text-rose-600 font-bold leading-none text-sm">×</button>
        </div>
      )}
      {open && matches.length > 0 && (
        <div data-testid={`${testId}-options`}
          className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border border-slate-300 rounded-md shadow-xl max-h-56 overflow-y-auto">
          {matches.map((p) => {
            const neg = (p.stock_qty ?? 0) <= 0;
            const low = !neg && (p.stock_qty ?? 0) <= (p.min_stock ?? 0);
            return (
              <button key={p.id} type="button" data-testid={`${testId}-option-${p.code}`}
                onMouseDown={(e) => { e.preventDefault(); onPick(p); setOpen(false); }}
                className="w-full text-left px-3 py-2 hover:bg-blue-50 border-b border-slate-100 last:border-0 transition-colors">
                <span className="block text-sm text-slate-900 leading-tight">{p.name}</span>
                <span className={`block text-[11px] font-medium ${neg ? "text-rose-600" : low ? "text-amber-600" : "text-emerald-700"}`}>
                  {p.sku ? `${p.sku} · ` : ""}estoque: {fmtQty(p.stock_qty)} {p.unit || ""}
                </span>
                {p.variation_alert_active && (
                  <span className="flex items-center gap-1 text-[11px] font-semibold text-amber-700">
                    <WarningCircle size={12} className="shrink-0" /> {p.variation_note || "Variação de medida no lote atual"}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
